"use client";
import { Typography } from "antd";
import Image from "next/image";
import React from "react";
import { OurProjectsContentsType } from "../types";

type OurProjectsProps = {
  isRtl: boolean;
  ourProjectsData: OurProjectsContentsType;
};

const OurProjects = ({ isRtl, ourProjectsData }: OurProjectsProps) => {
  const { Title } = Typography;
  return (
    <div
      className={`${
        isRtl ? "sm:flex-row-reverse" : "sm:flex-row"
      } flex flex-col gap-4 md:gap-6 lg:gap-10 xl:gap-20 justify-center items-center `}
    >
      <div className="w-full lg:max-w-[38rem]  rounded-lg block justify-center overflow-hidden">
        <Image
          src={ourProjectsData.url}
          width={0}
          height={0}
          alt={ourProjectsData.title}
          className="rounded-lg"
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </div>
      <div className="w-full flex flex-col gap-4 sm:gap-2 md:gap-4">
        <Title level={2} className="H2">
          {ourProjectsData.title}
        </Title>
        <div>
          <p>{ourProjectsData.description}</p>
          <ul className="list-disc pr-6">
            {ourProjectsData.items?.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
          <p>{ourProjectsData.footer}</p>
        </div>
      </div>
    </div>
  );
};

export default OurProjects;
